<template>
  <div>

    <div v-if="showIndex">

      <div class="row">
        <div class="col-sm-12">
          <h1 class="page-title pull-left">Manage Lookup Labels</h1>
        </div>
      </div>
      <div class="panel">
        <div class="panel-heading">
          <h3 class="panel-title">All</h3>
        </div>
        <div class="panel-body">
          <ul class="list-group">
            <li class="list-group-item"><router-link :to="{ name: 'lookup-achemicals' }">Achemcials</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-adultapprates' }">Adult App Rates</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-aequips' }">Aequips</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-applicators' }">Applicators</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-assays' }">Assays</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-contracts' }">Contracts</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-contract-addresses' }">Contract Addresses</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-control-actions' }">Control Actions</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-counties' }">Counties</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-habitats' }">Habitats</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-larva-counts' }">Larva Counts</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-larval-app-rates' }">Larval App Rates</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-lchemicals' }">Lchemcials</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-lequipments' }">Lequipments</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-mix-ratios' }">Mix Ratios</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-mosquito-species' }">Mosquito Species</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-municipalities' }">Municipalities</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-request-types' }">Request Types</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-results' }">Results</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-routes' }">Routes</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-route-section-zones' }">Route Section Zones</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-sra-options' }">Site Risk Assessment Options</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-states' }">States</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-subdivisions' }">Subdivisions</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-trap-nights' }">Trap Nights</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-trap-teams' }">Trap Teams</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-trap-types' }">Trap Types</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-trucks' }">Trucks</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-vizual-monitors' }">Visual Monitors</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-waters' }">Waters</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-wind-directions' }">Wind Directions</router-link></li>
            <li class="list-group-item"><router-link :to="{ name: 'lookup-zones' }">Zones</router-link></li>
          </ul>
        </div>
      </div>

    </div>

    <router-view></router-view>
  </div>
</template>

<script>

  export default {
    name: 'lookup',

    computed: {
      showIndex() {
        return this.$route.path === '/lookup';
      }
    },

    mounted() {
      if (!this.$store.getters.isAdmin) {
        this.$router.push({name: 'site-and-activity-map'});
      }
    }

  }

</script>

<style lang="scss">

</style>
